import "../styles/BodyShow.css";
import { useRef } from "react";
import { client } from "../api/Client";
export default function BodyShow(props) {
  let telRef = useRef();
  let nameRef = useRef();
  const handleUser = () => {
    if (!telRef.current.value || !nameRef.current.value) {
      alert("the fields is empyt 💢");
    } else {
      client
        .post("/AddLotUser", {
          Name: nameRef.current.value,
          Tel: telRef.current.value,
        })
        .then((res) => {
          if (res.data.error !== "this name or Number is used") {
            window.location.reload();
          } else {
            alert(res.data.error);
          }
        })
        .catch();
    }
  };
  return (
    <>
      <div className="ContainerBodyShow">
        <img src={props.Url} alt="beto" />
        <p>Try your luck, you may be the lucky one 🤝</p>
        <div className="ContainerForm">
          <div className="section">
            <lable for="name" className="lable">
              Name 📛 :
            </lable>
            <input type="text" id="name" ref={nameRef} />
          </div>
          <div className="section">
            <lable for="Number" className="lable">
              Telephone 📞 :
            </lable>
            <input type="tel" id="Number" ref={telRef} />
          </div>
          <button onClick={handleUser}>submit 🏃</button>
        </div>
      </div>
    </>
  );
}
